import translations from './translations'

translations.add('en', {
    threeDigitsDescription: 'A separate group of three digits on the right reverse of the card',
    fourDigitsDescription: 'Group of four digits on the front towards the right',
    cvcCode: 'CSC/CVV'
})
